<template>
  <div class="main">
    <div style="height:10px"></div>
    <div class="mainCont">
      <div class="mainList">
        <ul>
          <li>
            <div class="itemTil">就餐人数：</div>
            <div class="itemCont">{{bookingDetal.boNumber}}人</div>
          </li>
          <li>
            <div class="itemTil">预约时间：</div>
            <div class="itemCont">{{bookingDetal.boAppointment}}</div>
          </li>
          <li>
            <div class="itemTil">预定人名称：</div>
            <div class="itemCont">{{bookingDetal.boBookingPerson}}</div>
          </li>
          <li>
            <div class="itemTil">电话：</div>
            <div class="itemCont">{{bookingDetal.boPhone}}</div>
          </li>
          <li>
            <div class="itemTil">就餐地点：</div>
            <div class="itemCont">{{bookingDetal.cCanteenName}}</div>
          </li>
        </ul>
      </div>
      <div class="bomCont">
        <div v-if="type=='待就餐'" class="cancelBtn" @click="channelFunc">取消续约</div>
        <!-- <div @click="changeToPath" class="history">历史预约记录</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Vue from 'vue';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { addBaseAplus } from '../utils/zzdmd.js'
// 全局注册
Vue.use(Dialog);
Vue.use(Toast);
export default {
  name: 'appointDetail',
  data () {
    return {
      type:this.$route.query.type,
      bookingDetal:''
    }
  },
  created(){
    this.type = this.$route.query.type
    this.getBookingList()
  },
  mounted(){
    addBaseAplus(this.$route)
  },
  activated(){
    this.type = this.$route.query.type
    this.getBookingList()
  },
  methods:{
    getBookingList(){
      let param = {
        BookingOrderID:this.$route.query.id-0,
      }
       this.$post('api/Order/GetBookingOrderInfo', qs.stringify(param),{
        headers:{
            'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then((res)=>{
        if(res.code==1000){
          this.bookingDetal = res.data
        }
      })
    },
    changeToPath(){
      this.$router.push({path:'/order'})
    },
    channelFunc(){
      Dialog.confirm({
        title: '提示',
        message: '确认取消预约吗？',
        confirmButtonColor:'#3B87F5',
      }).then(() => {
          // on confirm
        let param = {
          BookingOrderID:this.$route.query.id-0
        }
        this.$post('api/Order/CancelOrder', qs.stringify(param),{
          headers:{
              'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          if(res.code==1000){
            Toast({
            message: '取消成功',
            position: 'bottom',
            })
            setTimeout(()=>{
              this.$router.go(-1)
            },1500)
          }else{
            Toast({
            message: res.msg||res.message,
            position: 'bottom',
            })
          }
        })
      }).catch(() => {
        // on cancel
      });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  background: #f2f2f2;
  min-height: 100vh;
  position: relative;
}
.mainCont{
  min-height: calc(100vh - 10px);
  background: #fff;
  box-sizing: border-box;
  padding: 0 13px;
}
.mainList{
  width: 100%;
}
.mainList>ul>li{
  box-sizing: border-box;
  padding: 15px 0;
  border-bottom: 1px solid #E6E6E6;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.itemTil{
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  min-width: 90px;
  white-space: nowrap;
}
.itemCont{
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  width: calc(100% - 90px);
}
.bomCont{
  margin: 50px 0 0;
}
.cancelBtn{
  width: 168px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  background: #E6E6E6;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #666666;
}
.history{
  margin-top: 15px;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #3B87F5;
}
</style>



// WEBPACK FOOTER //
// src/page/appointDetail.vue